import styled from 'styled-components';
import { useQuery } from 'react-query';
import Switch from 'react-switch';
import {
  breakpoint,
  theme,
  BaseUITextStyles,
  PrimaryButton,
  Pagination,
} from '@grays-npm/component-library';
import { getNotifications } from '../../services/notifications';
import { useCMSData } from '../../state/content-manager';
import {
  NotificationList,
  PageLayout,
  Loader,
  useAuthData,
} from '../../components';
import { StyledHeading } from '../styles';
import { useState } from 'react';
import { QUERY_KEYS } from 'utils/constants';

const Header = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: ${({ theme }) => theme.spacings[5].rem} 0;

  ${breakpoint('lg')`
    margin: 0 0 ${({ theme }) => theme.spacings[7].rem};
  `}
`;

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const SwitchLabel = styled.span`
  ${BaseUITextStyles}
  margin-right: ${({ theme }) => theme.spacings[2].rem};
`;

const StyledSwitch = styled(Switch)`
  vertical-align: middle;
  margin-right: ${({ theme }) => theme.spacings[4].rem};
`;

export const Notifications = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [showRead, setShowRead] = useState(false);
  const { token } = useAuthData();
  const { notifications } = useCMSData();

  // Queries
  const notificationsQuery = useQuery(
    [QUERY_KEYS.NOTIFICATIONS, token, showRead, currentPage],
    () => {
      const queryParams = {
        pageNumber: currentPage.toString(),
        pageSize: '10',
        includeRead: showRead.toString(),
      };
      return getNotifications(token, queryParams);
    }
  );

  const pageCount = notificationsQuery.data?.pagination?.pageCount || 1;

  return (
    <PageLayout
      bottomChildren={
        <Pagination
          currentPage={currentPage}
          onPageChange={setCurrentPage}
          pageCount={pageCount}
        />
      }
    >
      <Header>
        <StyledHeading size={4}>{notifications?.title}</StyledHeading>
        <Container>
          {
            // eslint-disable-next-line jsx-a11y/label-has-associated-control
            <label>
              <SwitchLabel size="md">Show read:</SwitchLabel>
              <StyledSwitch
                onChange={setShowRead}
                checked={showRead}
                onColor={theme.colors.primary.graysRed}
                uncheckedIcon={false}
                checkedIcon={false}
              />
            </label>
          }
          <PrimaryButton
            size="medium"
            onClick={() => console.log('mark all as read')}
          >
            Mark all as read
          </PrimaryButton>
        </Container>
      </Header>

      <Loader query={notificationsQuery}>
        {notificationsQuery.data && (
          <NotificationList
            notifications={notificationsQuery.data.data}
            emptyText="yolo"
          />
        )}
      </Loader>
    </PageLayout>
  );
};
